import { render, staticRenderFns } from "./WebUserRoles.vue?vue&type=template&id=a816876c&lang=pug&"
import script from "./WebUserRoles.vue?vue&type=script&lang=ts&"
export * from "./WebUserRoles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports